import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchOrchidAPI } from "utils/api";

const useSaveUserSettingsMutation = ({ userId }: { userId: string }) => {
  const queryClient = useQueryClient();

  const updateUserSettingsMutation = useMutation({
    mutationFn: async (settings: UserSettings) =>
      fetchOrchidAPI(`/api/users/v1/user_settings/${userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ settings }),
      }),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ["userSettings", { userId }],
      });
    },
  });
  return updateUserSettingsMutation;
};

export default useSaveUserSettingsMutation;
